export default __webpack_public_path__ + "static/media/TAPE.69e00aa8.svg";